module.exports = "/_next/static/fonts/founders-grotesk-condensed-web-medium-b910d6a3efec238ff5e56fdf7f2840a3.woff2";